import { useState, useCallback, useEffect } from 'react';
import { useApi } from '../../api/useApi';
import { User } from '../../api/userApi/UserApi';

const DEFAULT_LIMIT = 500;

export const useUsers = () => {
  const api = useApi();
  
  const [users, setUsers] = useState<User[]>([]);
  const [userDetail, setUserDetail] = useState<User | null>(null);

  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(1);
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(DEFAULT_LIMIT);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const response = await api.user.getUsers();
      setUsers(response.data.results ?? []);
      setCount(response.data.count ?? 0);
    } catch {
      setUsers([]);
      setCount(0);
    } finally {
      setLoading(false);
    }
  }, [page, limit, offset]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handlePagination = (newOffset: number, newPage: number) => {
    setOffset(newOffset);
    setPage(newPage);
  };

  const handleLimitChange = (newLimit: number) => {
    setLimit(newLimit);
    setPage(1);
    setOffset(0);
  };

  const openDetail = (user: User) => {
    setUserDetail(user);
  };

  const closeDetail = () => {
    setUserDetail(null);
  };

  return {
    users,
    count,
    loading,
    page,
    offset,
    limit,
    userDetail,
    openDetail,
    closeDetail,
    handlePagination,
    handleLimitChange,
  };
};
